import { render } from "./AXBinventory.vue?vue&type=template&id=4fe977a0&scoped=true"
import script from "./AXBinventory.vue?vue&type=script&lang=js"
export * from "./AXBinventory.vue?vue&type=script&lang=js"

import "./AXBinventory.vue?vue&type=style&index=0&id=4fe977a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fe977a0"

export default script